import React from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

import PartnersCarousel from './PartnersCarousel';
import PartnersGrid from './PartnersGrid';

const StyledTypography = styled(Typography)`
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  background: linear-gradient(90deg, rgb(159 45 235 / 100%), rgb(98 0 163 / 100%) );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const NuBenefitsList = ({ partnersList }) => (
  <Box
    tag="section"
    marginTop={{ xs: '60px', md: '80px' }}
  >
    <Typography
      variant="heading2"
      intlKey="BENEFITS.PARTNERS.TITLE"
      whiteSpace={{ xs: 'pre-line', md: 'nowrap' }}
      textAlign="center"
      marginBottom={{ xs: '6x', md: '40px' }}
      intlValues={{
        highlight: (
          <StyledTypography
            tag="span"
            variant="heading2"
            intlKey="BENEFTIS.PARTNERS.TITLE.HIGHLIGHT"
            textAlign="center"
            whiteSpace={{ xs: 'pre-line', md: 'nowrap' }}
          />
        ),
      }}
      paddingHorizontal={{ xs: '6x', md: '12x' }}
    />

    <Typography
      variant="subtitle1"
      intlKey="BENEFITS.PARTNERS.SUBTITLE"
      textAlign="center"
      intlValues={{
        strong: (...text) => (
          <Typography
            tag="span"
            variant="subtitle1"
            strong
          >
            {text}
          </Typography>
        ),
      }}
      paddingHorizontal={{ xs: '6x', md: '0' }}
      width={{ xs: '100%', md: '453px' }}
      margin="0 auto"
      whiteSpace={{ xs: 'pre-line', md: 'normal' }}
    />

    {/* Mobile carousel */}
    <Box
      background="linear-gradient(to bottom, white 0%, white 20%, #F8F8FA 20%, #F8F8FA 100%);"
      marginTop="10px"
      paddingTop="50px"
      paddingBottom="80px"
      width="100%"
      display={{ xs: 'block', md: 'none' }}
    >
      <PartnersCarousel partnersList={partnersList} />
    </Box>

    {/* Desktop grid */}

    <Box
      display={{ xs: 'none', md: 'block' }}
      background="linear-gradient(to bottom, white 0%, white 20%, #F8F8FA 20%, #F8F8FA 100%);"
      marginTop="50px"
      marginBottom="20px"
    >
      <PartnersGrid partnersList={partnersList} />
    </Box>

  </Box>

);

NuBenefitsList.propTypes = {
  partnersList: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      moreLink: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,

};

export default NuBenefitsList;
